import fetchData from './fetchData';
import showHide from './show-hide';
function submitForm(submitBtns, callback = 'none') {

	submitBtns.forEach(function(btn) {
		btn.addEventListener('click', validate);
	})

	function validate(e) {
		e.preventDefault();
		const form = this.closest('form');
			/*
		TODO присвоить isValid = false, добавить валидацию
		*/
		let isValid = true; 
		if (isValid) {
			sendData(form);
		}
	}

	function clearLabels(form) {
		const fields = form.querySelectorAll('.field');
		fields.forEach(field => {
			field.classList.remove('field--not-empty');
		})
	}

	function sendData(form, callback) {
		const url = form.dataset.url,
			data = new FormData(form),
			options = {
				body: data
			};
		// for (var value of data.values()) {
		// 	console.log(value);
		// }
		let status = form.querySelector('.form__warn');
		if (status) {
			status.style = 'color: red;';
		}
		
		fetchData(url, options).
			then(result => {
				console.log(result);
				if (!result.status && !result.ok) {
					let message = ``;
					console.log(typeof(result.errors));
					if (typeof(result.errors) !== 'string' ) {
						for (let key in result.errors) {
							message += result.errors[key] + `<br>`;
	
						}
					} else {
						message = result.errors;
					}
					//console.log(message);
					if (status) {
						status.innerHTML = message || result.globalMessage || 'что-то пошло не так';
					}

				} else {
					//успех
					form.reset();
					clearLabels(form);
					const modalSuccessTrigger = form.querySelector('[data-success]');
					if (modalSuccessTrigger) {
						const modalSuccessTriggerData = modalSuccessTrigger.dataset.success,
								modal = document.getElementById(modalSuccessTriggerData);
						showHide(modal);
						
					}
							

					if (status) {
						status.innerHTML = result.title || 'Отправлено';
						status.style = 'color: green;';
					}
					if (result.linkToRedirect) {
						window.location.replace('/cabinet/');
					}


				}

			})
	}

}

export default submitForm;